import {
  Box,
  Columns,
  Column,
  ContentBlock,
  Heading,
  Stack,
  Strong,
  Text,
} from 'braid-design-system';
import React from 'react';

import { CTAButton } from 'src/components';
import { CREATE_JOB, REGISTER } from 'src/shared/links';

import * as styles from './PromoTiles.css';

interface Props {
  title?: string;
  tiles: any[];
}

const PromoTiles = ({ title, tiles }: Props) => (
  <Box paddingBottom={['none', 'xlarge']}>
    <Box
      paddingTop="medium"
      paddingBottom={['large', 'none']}
      paddingX={['xlarge', 'none']}
    >
      <ContentBlock>
        {title && (
          <Box padding={['gutter', 'xlarge']} paddingBottom="large">
            <Heading align="center" level="2">
              {title}
            </Heading>
          </Box>
        )}
        <Columns collapseBelow="tablet" space={['gutter', 'none']} alignY="top">
          {tiles.map((obj: any, key: number) => (
            <Column key={key}>
              <Box padding="gutter" paddingBottom="large">
                <Stack space="xlarge" align="center">
                  <Box
                    className={styles.img}
                    style={{ backgroundImage: `url(${obj.icon})` }}
                  />
                  <Box textAlign="center" style={{ maxWidth: '300px' }}>
                    <Text size="large">{obj.text}</Text>
                  </Box>
                </Stack>
              </Box>
            </Column>
          ))}
        </Columns>
        <Box paddingY={['xlarge', 'large']}>
          <Stack space="large" align="center">
            <Text>
              <Strong>Keen to get started?</Strong>
            </Text>
            <CTAButton
              center
              text={{
                loggedIn: 'Create a job ad',
                loggedOut: 'Create a job ad',
              }}
              href={{
                loggedIn: CREATE_JOB,
                loggedOut: REGISTER,
              }}
              tracking={{
                loggedIn: 'create_job_link_pressed',
                loggedOut: 'register_link_pressed',
              }}
            />
          </Stack>
        </Box>
      </ContentBlock>
    </Box>
  </Box>
);

export default PromoTiles;
